export const themeMode = {
  Blue: {
    background: {
      primary: '#0e1928',
      secondary: '#132f4c',
      tertiary: '#555555',
      quaternary: '#666666'
    },
    text: {
      primary: '#ffffff',
      secondary: '#dddddd',
      tertiary: '#bbbbbb',
      quaternary: '#999999'
    },
    active: {
      primary: 'rgba(24, 67, 96, 0.4)',
      secondary: 'rgba(29, 77, 106, 0.2)',
      tertiary: '#555555',
      quaternary: '#666666'
    },
    border: {
      primary: '1px solid rgba(255, 255, 255, 0.5)',
      secondary: '1px solid rgba(255, 255, 255, 0.3)',
      tertiary: '1px solid rgba(255, 255, 255, 0.2)',
      quaternary: '1px solid rgba(255, 255, 255, 0.1)',
      dashed: '2px dashed rgba(255, 255, 255, 0.1)'
    },
    shadow: {
      container:
        '0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)',
      primary:
        '0 3px 5px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15)',
      secondary:
        '0 1px 3px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15)',
      inset:
        '0 0 0 3px hsla(0, 0%, 100%, 0), 0 0 0 4px hsla(0, 0%, 83.9%, 0), inset 0 2px 2px 0 rgba(0, 0, 0, .2)',
      bottom: '0 5px 5px rgba(0, 0, 0, 0.18)',
    },
  },
  Gray: {
    background: {
      primary: '#222831',
      secondary: '#393E46',
      tertiary: '#555555',
      quaternary: '#666666'
    },
    text: {
      primary: '#ffffff',
      secondary: '#dddddd',
      tertiary: '#bbbbbb',
      quaternary: '#999999'
    },
    active: {
      primary: 'rgba(24, 67, 96, 0.4)',
      secondary: 'rgba(29, 77, 106, 0.2)',
      tertiary: '#555555',
      quaternary: '#666666'
    },
    border: {
      primary: '1px solid rgba(255, 255, 255, 0.5)',
      secondary: '1px solid rgba(255, 255, 255, 0.3)',
      tertiary: '1px solid rgba(255, 255, 255, 0.2)',
      quaternary: '1px solid rgba(255, 255, 255, 0.1)',
      dashed: '2px dashed rgba(255, 255, 255, 0.1)'
    },
    shadow: {
      container:
        '0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)',
      primary:
        '0 3px 5px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15)',
      secondary:
        '0 1px 3px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15)',
      inset:
        '0 0 0 3px hsla(0, 0%, 100%, 0), 0 0 0 4px hsla(0, 0%, 83.9%, 0), inset 0 2px 2px 0 rgba(0, 0, 0, .2)',
      bottom: '0 5px 5px rgba(0, 0, 0, 0.18)',
    },
  },
  Light: {
    background: {
      primary: '#f2f2f2',
      secondary: '#e1e1e1',
      tertiary: '#eeeeee',
      quaternary: '#dddddd'
    },
    text: {
      primary: '#000000',
      secondary: '#333333',
      tertiary: '#555555',
      quaternary: '#666666'
    },
    active: {
      primary: '#cccccc55',
      secondary: '#99999922',
      tertiary: '#555555',
      quaternary: '#666666'
    },
    border: {
      primary: '1px solid rgba(0, 0, 0, 0.5)',
      secondary: '1px solid rgba(0, 0, 0, 0.3)',
      tertiary: '1px solid rgba(0, 0, 0, 0.2)',
      quaternary: '1px solid rgba(0, 0, 0, 0.1)',
      dashed: '2px dashed rgba(0, 0, 0, 0.1)'
    },
    shadow: {
      container:
        '0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)',
      primary:
        '0 3px 5px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15)',
      secondary:
        '0 1px 3px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15)',
      inset:
        '0 0 0 3px hsla(0, 0%, 100%, 0), 0 0 0 4px hsla(0, 0%, 83.9%, 0), inset 0 2px 2px 0 rgba(0, 0, 0, .2)',
      bottom: '0 5px 5px rgba(0, 0, 0, 0.18)',
    },
  },
  Dark: {
    background: {
      primary: '#313131',
      secondary: '#414141',
      tertiary: '#555555',
      quaternary: '#666666'
    },
    text: {
      primary: '#ffffff',
      secondary: '#cccccc',
      tertiary: '#aaaaaa',
      quaternary: '#777777'
    },
    active: {
      primary: '#cccccc55',
      secondary: '#99999922',
      tertiary: '#777777',
      quaternary: '#555555'
    },
    border: {
      primary: '1px solid rgba(255, 255, 255, 0.5)',
      secondary: '1px solid rgba(255, 255, 255, 0.3)',
      tertiary: '1px solid rgba(255, 255, 255, 0.2)',
      quaternary: '1px solid rgba(255, 255, 255, 0.1)',
      dashed: '2px dashed rgba(255, 255, 255, 0.1)'
    },
    shadow: {
      container:
        '0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)',
      primary:
        '0 3px 5px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15)',
      secondary:
        '0 1px 3px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15)',
      inset:
        '0 0 0 3px hsla(0, 0%, 100%, 0), 0 0 0 4px hsla(0, 0%, 83.9%, 0), inset 0 2px 2px 0 rgba(0, 0, 0, .2)',
      bottom: '0 5px 5px rgba(0, 0, 0, 0.18)',
    },
  },
}

export const themeStyle = {
  radius: {
    primary: '5px',
    secondary: '7px',
    ternary: '10px',
    quaternary: '13px',
    circle: '50%',
    rounded: '20px',
  },
  font: {
    family: `-apple-system, BlinkMacSystemFont, Arial, 'Open Sans', 'Helvetica Neue', 'Hanuman', sans-serif`,
    weight: 300,
  },
  color: {
    error: '#d32f2f',
    success: '#43a047',
    info: '#2196f3',
    warning: '#ff9800',
  },
  responsive: {
    mobile: {
      text: {
        primary: 14,
        secondary: 13,
        tertiary: 12,
        quaternary: 11,
        h5: 17,
        h4: 19,
        h3: 21,
        h2: 23,
        h1: 25
      }
    },
    tablet: {
      text: {
        primary: 16,
        secondary: 15,
        tertiary: 14,
        quaternary: 13,
        h5: 19,
        h4: 21,
        h3: 23,
        h2: 25,
        h1: 27
      }
    },
    laptop: {
      text: {
        primary: 16,
        secondary: 15,
        tertiary: 14,
        quaternary: 13,
        h5: 19,
        h4: 21,
        h3: 23,
        h2: 25,
        h1: 27
      }
    },
    desktop: {
      text: {
        primary: 16,
        secondary: 15,
        tertiary: 14,
        quaternary: 13,
        h5: 19,
        h4: 21,
        h3: 23,
        h2: 25,
        h1: 27
      }
    },
  },
}
